import { render, staticRenderFns } from "./monthDetail.vue?vue&type=template&id=89fe532e&scoped=true&"
import script from "./monthDetail.vue?vue&type=script&lang=js&"
export * from "./monthDetail.vue?vue&type=script&lang=js&"
import style0 from "./monthDetail.vue?vue&type=style&index=0&id=89fe532e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fe532e",
  null
  
)

export default component.exports